(function () {
  'use strict';

  var body = document.body;
  var nav = document.querySelector('.drawer-nav');
  var toggles = document.querySelectorAll('.drawer-toggle');

  function openDrawer() {
    body.classList.add('drawer-open');
    if (nav) nav.setAttribute('aria-hidden', 'false');
  }
  function closeDrawer() {
    body.classList.remove('drawer-open');
    if (nav) nav.setAttribute('aria-hidden', 'true');
  }
  function toggleDrawer() {
    if (body.classList.contains('drawer-open')) { closeDrawer(); } else { openDrawer(); }
  }

  toggles.forEach(function (t) {
    t.addEventListener('click', function (e) {
      e.preventDefault();
      toggleDrawer();
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  // Sticky header: scroll past threshold で #scl_header.is-show を toggle
  var sticky = document.getElementById('scl_header');
  if (sticky) {
    var threshold = 200;
    var update = function () {
      if (window.scrollY > threshold) {
        sticky.classList.add('is-show');
      } else {
        sticky.classList.remove('is-show');
      }
    };
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  document.querySelectorAll('a[href^="#"]:not(.inline):not([data-lity])').forEach(function (a) {
    var href = a.getAttribute('href');
    if (!href || href === '#' || href.length < 2) return;
    a.addEventListener('click', function (e) {
      var target = document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  var pageTop = document.querySelector('#page_top a');
  if (pageTop) {
    pageTop.addEventListener('click', function (e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  // m_nav dropdown: .menu_fir / .menu_med の親 a クリックで子 .in_menu を toggle
  // 元サイトの jQuery openSubMenuLong() 相当 (vanilla JS で書き直し)
  document.querySelectorAll('.m_nav > li.menu_fir, .m_nav > li.menu_med').forEach(function (li) {
    var trigger = li.querySelector(':scope > a');
    var subMenu = li.querySelector(':scope > .in_menu');
    if (!trigger || !subMenu) return;
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      var isOpen = subMenu.classList.contains('is-open');
      // 他の開いてる in_menu を全部閉じる
      document.querySelectorAll('.m_nav .in_menu.is-open').forEach(function (other) {
        other.classList.remove('is-open');
        other.style.display = 'none';
      });
      // 自分は閉じてた場合のみ開く (再クリックでトグル閉じ)
      if (!isOpen) {
        subMenu.classList.add('is-open');
        subMenu.style.display = 'block';
      }
    });
  });
  // メニュー外クリックで開いてる in_menu を閉じる
  document.addEventListener('click', function (e) {
    if (e.target.closest('.m_nav > li.menu_fir, .m_nav > li.menu_med')) return;
    document.querySelectorAll('.m_nav .in_menu.is-open').forEach(function (open) {
      open.classList.remove('is-open');
      open.style.display = 'none';
    });
  });

  // FAQ アコーディオン: .faq_box h4 クリックで .open トグル + 次の .open_box を表示/非表示
  // (元 mrc サイトの jQuery slideToggle 相当・vanilla で書き直し)
  document.querySelectorAll('.faq_box h4').forEach(function (h4) {
    h4.style.cursor = 'pointer';
    h4.addEventListener('click', function () {
      var openBox = h4.parentElement.querySelector(':scope > .open_box');
      if (!openBox) return;
      var isOpen = h4.classList.toggle('open');
      openBox.style.display = isOpen ? 'block' : 'none';
    });
  });
})();
